/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ListAverageWeeklyHoursReportsResponse,
  ListBradfordFactorReportResponse,
  ListSalesVersusCostReportsByDayResponse,
  ListShiftCostReportsByDayResponse,
  ListShiftCostReportsByEmployeeResponse,
  ListShiftCostReportsByEmploymentTypeResponse,
  ListShiftCostReportsByGroupResponse,
  ListShiftCostReportsByJobRoleResponse,
  ListShiftCostReportsByLocationResponse,
  ShiftiePlainDate,
} from '../models/index';
import {
    ListAverageWeeklyHoursReportsResponseFromJSON,
    ListAverageWeeklyHoursReportsResponseToJSON,
    ListBradfordFactorReportResponseFromJSON,
    ListBradfordFactorReportResponseToJSON,
    ListSalesVersusCostReportsByDayResponseFromJSON,
    ListSalesVersusCostReportsByDayResponseToJSON,
    ListShiftCostReportsByDayResponseFromJSON,
    ListShiftCostReportsByDayResponseToJSON,
    ListShiftCostReportsByEmployeeResponseFromJSON,
    ListShiftCostReportsByEmployeeResponseToJSON,
    ListShiftCostReportsByEmploymentTypeResponseFromJSON,
    ListShiftCostReportsByEmploymentTypeResponseToJSON,
    ListShiftCostReportsByGroupResponseFromJSON,
    ListShiftCostReportsByGroupResponseToJSON,
    ListShiftCostReportsByJobRoleResponseFromJSON,
    ListShiftCostReportsByJobRoleResponseToJSON,
    ListShiftCostReportsByLocationResponseFromJSON,
    ListShiftCostReportsByLocationResponseToJSON,
    ShiftiePlainDateFromJSON,
    ShiftiePlainDateToJSON,
} from '../models/index';

export interface ListAverageWeeklyHoursReportsRequest {
    startsAt: Date;
    endsAt: Date;
    page?: number;
    perPage?: number;
    includeArchivedData?: boolean;
    includeUnscheduledTimesheets?: boolean;
    includeUnapprovedTimesheets?: boolean;
}

export interface ListBradfordFactorReportRequest {
    startDate: ShiftiePlainDate;
    endDate: ShiftiePlainDate;
    perPage?: number;
    page?: number;
    absenceCategoryIds?: Array<number>;
    includeArchivedData?: boolean;
}

export interface ListSalesVersusCostReportsByDayRequest {
    scheduleId: number;
    page?: number;
    perPage?: number;
    locationIds?: Array<number>;
    employeeIds?: Array<number>;
    employeeGroupIds?: Array<number>;
    employmentTypes?: Array<ListSalesVersusCostReportsByDayEmploymentTypesEnum>;
    excludeRecordsOfType?: Array<ListSalesVersusCostReportsByDayExcludeRecordsOfTypeEnum>;
    includeArchivedData?: boolean;
    startsAt?: Date;
    endsAt?: Date;
    startTime?: string;
    endTime?: string;
}

export interface ListShiftCostReportsByDayRequest {
    page?: number;
    perPage?: number;
    locationIds?: Array<number>;
    jobRoleIds?: Array<number>;
    employeeIds?: Array<number>;
    employeeGroupIds?: Array<number>;
    scheduleId?: number;
    publishedShifts?: boolean;
    includeArchivedData?: boolean;
    includeUnscheduledTimesheets?: boolean;
    startsAt?: Date;
    endsAt?: Date;
}

export interface ListShiftCostReportsByEmployeeRequest {
    page?: number;
    perPage?: number;
    locationIds?: Array<number>;
    jobRoleIds?: Array<number>;
    employeeIds?: Array<number>;
    employeeGroupIds?: Array<number>;
    publishedShifts?: boolean;
    includeArchivedData?: boolean;
    startsAt?: Date;
    endsAt?: Date;
}

export interface ListShiftCostReportsByEmploymentTypeRequest {
    page?: number;
    perPage?: number;
    locationIds?: Array<number>;
    jobRoleIds?: Array<number>;
    employeeIds?: Array<number>;
    employeeGroupIds?: Array<number>;
    publishedShifts?: boolean;
    includeArchivedData?: boolean;
    startsAt?: Date;
    endsAt?: Date;
}

export interface ListShiftCostReportsByGroupRequest {
    page?: number;
    perPage?: number;
    locationIds?: Array<number>;
    jobRoleIds?: Array<number>;
    employeeIds?: Array<number>;
    employeeGroupIds?: Array<number>;
    publishedShifts?: boolean;
    includeArchivedData?: boolean;
    startsAt?: Date;
    endsAt?: Date;
}

export interface ListShiftCostReportsByJobRoleRequest {
    page?: number;
    perPage?: number;
    locationIds?: Array<number>;
    jobRoleIds?: Array<number>;
    employeeIds?: Array<number>;
    employeeGroupIds?: Array<number>;
    publishedShifts?: boolean;
    includeArchivedData?: boolean;
    startsAt?: Date;
    endsAt?: Date;
}

export interface ListShiftCostReportsByLocationRequest {
    page?: number;
    perPage?: number;
    locationIds?: Array<number>;
    jobRoleIds?: Array<number>;
    employeeIds?: Array<number>;
    employeeGroupIds?: Array<number>;
    publishedShifts?: boolean;
    includeArchivedData?: boolean;
    startsAt?: Date;
    endsAt?: Date;
}

/**
 * 
 */
export class ReportsApi extends runtime.BaseAPI {

    /**
     * Get a report of the average weekly scheduled, worked and overtime hours per employee.
     * Average Weekly Hours
     */
    async listAverageWeeklyHoursReportsRaw(requestParameters: ListAverageWeeklyHoursReportsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListAverageWeeklyHoursReportsResponse>> {
        if (requestParameters['startsAt'] == null) {
            throw new runtime.RequiredError(
                'startsAt',
                'Required parameter "startsAt" was null or undefined when calling listAverageWeeklyHoursReports().'
            );
        }

        if (requestParameters['endsAt'] == null) {
            throw new runtime.RequiredError(
                'endsAt',
                'Required parameter "endsAt" was null or undefined when calling listAverageWeeklyHoursReports().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['perPage'] != null) {
            queryParameters['perPage'] = requestParameters['perPage'];
        }

        if (requestParameters['includeArchivedData'] != null) {
            queryParameters['includeArchivedData'] = requestParameters['includeArchivedData'];
        }

        if (requestParameters['includeUnscheduledTimesheets'] != null) {
            queryParameters['includeUnscheduledTimesheets'] = requestParameters['includeUnscheduledTimesheets'];
        }

        if (requestParameters['includeUnapprovedTimesheets'] != null) {
            queryParameters['includeUnapprovedTimesheets'] = requestParameters['includeUnapprovedTimesheets'];
        }

        if (requestParameters['startsAt'] != null) {
            queryParameters['startsAt'] = (requestParameters['startsAt'] as any).toISOString();
        }

        if (requestParameters['endsAt'] != null) {
            queryParameters['endsAt'] = (requestParameters['endsAt'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", ["api.v1.average-weekly-hours-report.read"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/reports/average-weekly-hours`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListAverageWeeklyHoursReportsResponseFromJSON(jsonValue));
    }

    /**
     * Get a report of the average weekly scheduled, worked and overtime hours per employee.
     * Average Weekly Hours
     */
    async listAverageWeeklyHoursReports(requestParameters: ListAverageWeeklyHoursReportsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListAverageWeeklyHoursReportsResponse> {
        const response = await this.listAverageWeeklyHoursReportsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a Bradford Factor report for employees
     * List Bradford Factor Report
     */
    async listBradfordFactorReportRaw(requestParameters: ListBradfordFactorReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListBradfordFactorReportResponse>> {
        if (requestParameters['startDate'] == null) {
            throw new runtime.RequiredError(
                'startDate',
                'Required parameter "startDate" was null or undefined when calling listBradfordFactorReport().'
            );
        }

        if (requestParameters['endDate'] == null) {
            throw new runtime.RequiredError(
                'endDate',
                'Required parameter "endDate" was null or undefined when calling listBradfordFactorReport().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['perPage'] != null) {
            queryParameters['perPage'] = requestParameters['perPage'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = requestParameters['startDate'];
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = requestParameters['endDate'];
        }

        if (requestParameters['absenceCategoryIds'] != null) {
            queryParameters['absenceCategoryIds'] = requestParameters['absenceCategoryIds'];
        }

        if (requestParameters['includeArchivedData'] != null) {
            queryParameters['includeArchivedData'] = requestParameters['includeArchivedData'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", ["api.v1.report-bradford-factor.read"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/reports/absence/bradford-factor`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListBradfordFactorReportResponseFromJSON(jsonValue));
    }

    /**
     * Get a Bradford Factor report for employees
     * List Bradford Factor Report
     */
    async listBradfordFactorReport(requestParameters: ListBradfordFactorReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListBradfordFactorReportResponse> {
        const response = await this.listBradfordFactorReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a report of sales versus costs with various filters broken down by Days.
     * Sales Versus Costs By Days
     */
    async listSalesVersusCostReportsByDayRaw(requestParameters: ListSalesVersusCostReportsByDayRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListSalesVersusCostReportsByDayResponse>> {
        if (requestParameters['scheduleId'] == null) {
            throw new runtime.RequiredError(
                'scheduleId',
                'Required parameter "scheduleId" was null or undefined when calling listSalesVersusCostReportsByDay().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['perPage'] != null) {
            queryParameters['perPage'] = requestParameters['perPage'];
        }

        if (requestParameters['locationIds'] != null) {
            queryParameters['locationIds'] = requestParameters['locationIds'];
        }

        if (requestParameters['employeeIds'] != null) {
            queryParameters['employeeIds'] = requestParameters['employeeIds'];
        }

        if (requestParameters['employeeGroupIds'] != null) {
            queryParameters['employeeGroupIds'] = requestParameters['employeeGroupIds'];
        }

        if (requestParameters['employmentTypes'] != null) {
            queryParameters['employmentTypes'] = requestParameters['employmentTypes'];
        }

        if (requestParameters['excludeRecordsOfType'] != null) {
            queryParameters['excludeRecordsOfType'] = requestParameters['excludeRecordsOfType'];
        }

        if (requestParameters['scheduleId'] != null) {
            queryParameters['scheduleId'] = requestParameters['scheduleId'];
        }

        if (requestParameters['includeArchivedData'] != null) {
            queryParameters['includeArchivedData'] = requestParameters['includeArchivedData'];
        }

        if (requestParameters['startsAt'] != null) {
            queryParameters['startsAt'] = (requestParameters['startsAt'] as any).toISOString();
        }

        if (requestParameters['endsAt'] != null) {
            queryParameters['endsAt'] = (requestParameters['endsAt'] as any).toISOString();
        }

        if (requestParameters['startTime'] != null) {
            queryParameters['startTime'] = requestParameters['startTime'];
        }

        if (requestParameters['endTime'] != null) {
            queryParameters['endTime'] = requestParameters['endTime'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", ["api.v1.shift-cost-report.read"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/reports/sales-versus-costs`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListSalesVersusCostReportsByDayResponseFromJSON(jsonValue));
    }

    /**
     * Get a report of sales versus costs with various filters broken down by Days.
     * Sales Versus Costs By Days
     */
    async listSalesVersusCostReportsByDay(requestParameters: ListSalesVersusCostReportsByDayRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListSalesVersusCostReportsByDayResponse> {
        const response = await this.listSalesVersusCostReportsByDayRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a shift costs report broken down by Days.
     * Shift Costs By Days
     */
    async listShiftCostReportsByDayRaw(requestParameters: ListShiftCostReportsByDayRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListShiftCostReportsByDayResponse>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['perPage'] != null) {
            queryParameters['perPage'] = requestParameters['perPage'];
        }

        if (requestParameters['locationIds'] != null) {
            queryParameters['locationIds'] = requestParameters['locationIds'];
        }

        if (requestParameters['jobRoleIds'] != null) {
            queryParameters['jobRoleIds'] = requestParameters['jobRoleIds'];
        }

        if (requestParameters['employeeIds'] != null) {
            queryParameters['employeeIds'] = requestParameters['employeeIds'];
        }

        if (requestParameters['employeeGroupIds'] != null) {
            queryParameters['employeeGroupIds'] = requestParameters['employeeGroupIds'];
        }

        if (requestParameters['scheduleId'] != null) {
            queryParameters['scheduleId'] = requestParameters['scheduleId'];
        }

        if (requestParameters['publishedShifts'] != null) {
            queryParameters['publishedShifts'] = requestParameters['publishedShifts'];
        }

        if (requestParameters['includeArchivedData'] != null) {
            queryParameters['includeArchivedData'] = requestParameters['includeArchivedData'];
        }

        if (requestParameters['includeUnscheduledTimesheets'] != null) {
            queryParameters['includeUnscheduledTimesheets'] = requestParameters['includeUnscheduledTimesheets'];
        }

        if (requestParameters['startsAt'] != null) {
            queryParameters['startsAt'] = (requestParameters['startsAt'] as any).toISOString();
        }

        if (requestParameters['endsAt'] != null) {
            queryParameters['endsAt'] = (requestParameters['endsAt'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", ["api.v1.shift-cost-report.read"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/reports/costs/daily`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListShiftCostReportsByDayResponseFromJSON(jsonValue));
    }

    /**
     * Get a shift costs report broken down by Days.
     * Shift Costs By Days
     */
    async listShiftCostReportsByDay(requestParameters: ListShiftCostReportsByDayRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListShiftCostReportsByDayResponse> {
        const response = await this.listShiftCostReportsByDayRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a shift costs report broken down by Employment Type.
     * Shift Costs By Employee
     */
    async listShiftCostReportsByEmployeeRaw(requestParameters: ListShiftCostReportsByEmployeeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListShiftCostReportsByEmployeeResponse>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['perPage'] != null) {
            queryParameters['perPage'] = requestParameters['perPage'];
        }

        if (requestParameters['locationIds'] != null) {
            queryParameters['locationIds'] = requestParameters['locationIds'];
        }

        if (requestParameters['jobRoleIds'] != null) {
            queryParameters['jobRoleIds'] = requestParameters['jobRoleIds'];
        }

        if (requestParameters['employeeIds'] != null) {
            queryParameters['employeeIds'] = requestParameters['employeeIds'];
        }

        if (requestParameters['employeeGroupIds'] != null) {
            queryParameters['employeeGroupIds'] = requestParameters['employeeGroupIds'];
        }

        if (requestParameters['publishedShifts'] != null) {
            queryParameters['publishedShifts'] = requestParameters['publishedShifts'];
        }

        if (requestParameters['includeArchivedData'] != null) {
            queryParameters['includeArchivedData'] = requestParameters['includeArchivedData'];
        }

        if (requestParameters['startsAt'] != null) {
            queryParameters['startsAt'] = (requestParameters['startsAt'] as any).toISOString();
        }

        if (requestParameters['endsAt'] != null) {
            queryParameters['endsAt'] = (requestParameters['endsAt'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", ["api.v1.shift-cost-report.read"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/reports/costs/by-employee`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListShiftCostReportsByEmployeeResponseFromJSON(jsonValue));
    }

    /**
     * Get a shift costs report broken down by Employment Type.
     * Shift Costs By Employee
     */
    async listShiftCostReportsByEmployee(requestParameters: ListShiftCostReportsByEmployeeRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListShiftCostReportsByEmployeeResponse> {
        const response = await this.listShiftCostReportsByEmployeeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a shift costs report broken down by Employment Type.
     * Shift Costs By Employment Type
     */
    async listShiftCostReportsByEmploymentTypeRaw(requestParameters: ListShiftCostReportsByEmploymentTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListShiftCostReportsByEmploymentTypeResponse>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['perPage'] != null) {
            queryParameters['perPage'] = requestParameters['perPage'];
        }

        if (requestParameters['locationIds'] != null) {
            queryParameters['locationIds'] = requestParameters['locationIds'];
        }

        if (requestParameters['jobRoleIds'] != null) {
            queryParameters['jobRoleIds'] = requestParameters['jobRoleIds'];
        }

        if (requestParameters['employeeIds'] != null) {
            queryParameters['employeeIds'] = requestParameters['employeeIds'];
        }

        if (requestParameters['employeeGroupIds'] != null) {
            queryParameters['employeeGroupIds'] = requestParameters['employeeGroupIds'];
        }

        if (requestParameters['publishedShifts'] != null) {
            queryParameters['publishedShifts'] = requestParameters['publishedShifts'];
        }

        if (requestParameters['includeArchivedData'] != null) {
            queryParameters['includeArchivedData'] = requestParameters['includeArchivedData'];
        }

        if (requestParameters['startsAt'] != null) {
            queryParameters['startsAt'] = (requestParameters['startsAt'] as any).toISOString();
        }

        if (requestParameters['endsAt'] != null) {
            queryParameters['endsAt'] = (requestParameters['endsAt'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", ["api.v1.shift-cost-report.read"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/reports/costs/by-employment-type`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListShiftCostReportsByEmploymentTypeResponseFromJSON(jsonValue));
    }

    /**
     * Get a shift costs report broken down by Employment Type.
     * Shift Costs By Employment Type
     */
    async listShiftCostReportsByEmploymentType(requestParameters: ListShiftCostReportsByEmploymentTypeRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListShiftCostReportsByEmploymentTypeResponse> {
        const response = await this.listShiftCostReportsByEmploymentTypeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a shift costs report broken down by Group.
     * Shift Costs By Group
     */
    async listShiftCostReportsByGroupRaw(requestParameters: ListShiftCostReportsByGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListShiftCostReportsByGroupResponse>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['perPage'] != null) {
            queryParameters['perPage'] = requestParameters['perPage'];
        }

        if (requestParameters['locationIds'] != null) {
            queryParameters['locationIds'] = requestParameters['locationIds'];
        }

        if (requestParameters['jobRoleIds'] != null) {
            queryParameters['jobRoleIds'] = requestParameters['jobRoleIds'];
        }

        if (requestParameters['employeeIds'] != null) {
            queryParameters['employeeIds'] = requestParameters['employeeIds'];
        }

        if (requestParameters['employeeGroupIds'] != null) {
            queryParameters['employeeGroupIds'] = requestParameters['employeeGroupIds'];
        }

        if (requestParameters['publishedShifts'] != null) {
            queryParameters['publishedShifts'] = requestParameters['publishedShifts'];
        }

        if (requestParameters['includeArchivedData'] != null) {
            queryParameters['includeArchivedData'] = requestParameters['includeArchivedData'];
        }

        if (requestParameters['startsAt'] != null) {
            queryParameters['startsAt'] = (requestParameters['startsAt'] as any).toISOString();
        }

        if (requestParameters['endsAt'] != null) {
            queryParameters['endsAt'] = (requestParameters['endsAt'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", ["api.v1.shift-cost-report.read"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/reports/costs/by-group`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListShiftCostReportsByGroupResponseFromJSON(jsonValue));
    }

    /**
     * Get a shift costs report broken down by Group.
     * Shift Costs By Group
     */
    async listShiftCostReportsByGroup(requestParameters: ListShiftCostReportsByGroupRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListShiftCostReportsByGroupResponse> {
        const response = await this.listShiftCostReportsByGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a shift costs report broken down by Job Role.
     * Shift Costs By Job Role
     */
    async listShiftCostReportsByJobRoleRaw(requestParameters: ListShiftCostReportsByJobRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListShiftCostReportsByJobRoleResponse>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['perPage'] != null) {
            queryParameters['perPage'] = requestParameters['perPage'];
        }

        if (requestParameters['locationIds'] != null) {
            queryParameters['locationIds'] = requestParameters['locationIds'];
        }

        if (requestParameters['jobRoleIds'] != null) {
            queryParameters['jobRoleIds'] = requestParameters['jobRoleIds'];
        }

        if (requestParameters['employeeIds'] != null) {
            queryParameters['employeeIds'] = requestParameters['employeeIds'];
        }

        if (requestParameters['employeeGroupIds'] != null) {
            queryParameters['employeeGroupIds'] = requestParameters['employeeGroupIds'];
        }

        if (requestParameters['publishedShifts'] != null) {
            queryParameters['publishedShifts'] = requestParameters['publishedShifts'];
        }

        if (requestParameters['includeArchivedData'] != null) {
            queryParameters['includeArchivedData'] = requestParameters['includeArchivedData'];
        }

        if (requestParameters['startsAt'] != null) {
            queryParameters['startsAt'] = (requestParameters['startsAt'] as any).toISOString();
        }

        if (requestParameters['endsAt'] != null) {
            queryParameters['endsAt'] = (requestParameters['endsAt'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", ["api.v1.shift-cost-report.read"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/reports/costs/by-job-role`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListShiftCostReportsByJobRoleResponseFromJSON(jsonValue));
    }

    /**
     * Get a shift costs report broken down by Job Role.
     * Shift Costs By Job Role
     */
    async listShiftCostReportsByJobRole(requestParameters: ListShiftCostReportsByJobRoleRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListShiftCostReportsByJobRoleResponse> {
        const response = await this.listShiftCostReportsByJobRoleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a shift costs report broken down by Location.
     * Shift Costs By Location
     */
    async listShiftCostReportsByLocationRaw(requestParameters: ListShiftCostReportsByLocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListShiftCostReportsByLocationResponse>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['perPage'] != null) {
            queryParameters['perPage'] = requestParameters['perPage'];
        }

        if (requestParameters['locationIds'] != null) {
            queryParameters['locationIds'] = requestParameters['locationIds'];
        }

        if (requestParameters['jobRoleIds'] != null) {
            queryParameters['jobRoleIds'] = requestParameters['jobRoleIds'];
        }

        if (requestParameters['employeeIds'] != null) {
            queryParameters['employeeIds'] = requestParameters['employeeIds'];
        }

        if (requestParameters['employeeGroupIds'] != null) {
            queryParameters['employeeGroupIds'] = requestParameters['employeeGroupIds'];
        }

        if (requestParameters['publishedShifts'] != null) {
            queryParameters['publishedShifts'] = requestParameters['publishedShifts'];
        }

        if (requestParameters['includeArchivedData'] != null) {
            queryParameters['includeArchivedData'] = requestParameters['includeArchivedData'];
        }

        if (requestParameters['startsAt'] != null) {
            queryParameters['startsAt'] = (requestParameters['startsAt'] as any).toISOString();
        }

        if (requestParameters['endsAt'] != null) {
            queryParameters['endsAt'] = (requestParameters['endsAt'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", ["api.v1.shift-cost-report.read"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/reports/costs/by-location`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListShiftCostReportsByLocationResponseFromJSON(jsonValue));
    }

    /**
     * Get a shift costs report broken down by Location.
     * Shift Costs By Location
     */
    async listShiftCostReportsByLocation(requestParameters: ListShiftCostReportsByLocationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListShiftCostReportsByLocationResponse> {
        const response = await this.listShiftCostReportsByLocationRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
  * @export
  * @enum {string}
  */
export enum ListSalesVersusCostReportsByDayEmploymentTypesEnum {
    Agency = 'Agency',
    AnnualisedContract = 'Annualised Contract',
    ApprenticeTrainee = 'Apprentice / Trainee',
    Casual = 'Casual',
    FixedTerm = 'Fixed Term',
    FullTime = 'Full Time',
    PartTime = 'Part Time',
    SelfEmployed = 'Self-Employed',
    Temporary = 'Temporary',
    Volunteer = 'Volunteer'
}
/**
  * @export
  * @enum {string}
  */
export enum ListSalesVersusCostReportsByDayExcludeRecordsOfTypeEnum {
    Absence = 'absence',
    AssignedShifts = 'assigned shifts',
    Leave = 'leave',
    OpenShifts = 'open shifts',
    UnassignedShifts = 'unassigned shifts'
}
